import BaseModel from '../core/BaseModel'
//import PropertyTypeModel from '@/models/PropertyTypeModel'
export default class AdminPropertyModel extends BaseModel {

    constructor() {
        super({
                name: "admin_property",
                tableName: 'admin_property',
                label: "admin_property",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                detail_get1: {
                    refs:  'uid property_id',
                    display: false
                },
            })
    }

}